/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { ButtonBase, Typography2 } from '@coursera/cds-core';
import { CloseIcon } from '@coursera/cds-icons';

import Tooltip, { type Props as TooltipProps } from 'bundles/common/components/Tooltip/Tooltip';
import TooltipArrow from 'bundles/common/components/Tooltip/TooltipArrow';

import _t from 'i18n!nls/cml';

type Props = TooltipProps & {
  onDismiss: () => void;
};

const styles = {
  tooltip: css`
    background-color: var(--cds-color-emphasis-primary-background-xxstrong);
    max-width: 240px;
  `,
  tooltipArrow: css`
    border-bottom-color: var(--cds-color-emphasis-primary-background-xxstrong);
  `,
  label: css`
    text-align: left;
    margin: var(--cds-spacing-150);
  `,
  title: css`
    margin-bottom: var(--cds-spacing-100);
  `,
  closeButton: css`
    position: absolute;
    top: var(--cds-spacing-50);
    right: var(--cds-spacing-50);
  `,
};

const AILayoutDiscoveryTooltip = React.forwardRef<HTMLDivElement, Props>(({ onDismiss, ...props }, ref) => {
  return (
    <Tooltip
      ref={ref}
      {...props}
      css={styles.tooltip}
      arrow={<TooltipArrow placement="bottom" variant="primary" css={styles.tooltipArrow} />}
    >
      <div css={styles.label}>
        <Typography2 css={styles.title} color="invertBody" component="p" variant="subtitleMedium">
          {_t('Auto-layout now available')}
        </Typography2>
        <Typography2 color="invertBody" component="p" variant="bodySecondary">
          {_t('Engage learners by improving the layout of your Reading using the power of AI!')}
        </Typography2>
      </div>
      <ButtonBase onClick={onDismiss} aria-label={_t('Dismiss')} css={styles.closeButton}>
        <CloseIcon />
      </ButtonBase>
    </Tooltip>
  );
});

export default AILayoutDiscoveryTooltip;
